export default "__VITE_ASSET__UVOGww04__"